function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Nuevo-portal",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Header-y-bloque-usuario",
  transform: "translate(-1358.000000, -849.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "UI-icon/User/outline/Orange",
  transform: "translate(1358.000000, 849.000000)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Bounds",
  x: 0,
  y: 0,
  width: 28,
  height: 28
}), /*#__PURE__*/React.createElement("path", {
  d: "M3.0045269,21.4962204 C3.17315063,17.8485847 8.03128421,14.9230769 14,14.9230769 C20.0753,14.9230769 25,17.954 25,21.6923077 L25,21.6923077 L25,25.1641827 C25,25.4740865 24.89055,25.9230769 24.57155,25.9230769 L3.70345,25.9230769 C3.39105,25.9230769 3,25.4703846 3,25.1641827 L3,21.6923077 Z M14,3.07692308 C17.2711538,3.07692308 19.9230769,5.72884615 19.9230769,9 C19.9230769,12.2711538 17.2711538,14.9230769 14,14.9230769 C10.7288462,14.9230769 8.07692308,12.2711538 8.07692308,9 C8.07692308,5.72884615 10.7288462,3.07692308 14,3.07692308 Z",
  id: "Stroke-13",
  stroke: "#EB5F0A",
  strokeLinecap: "round"
}))));

function SvgIconUserempty(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "28px",
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "2A3DDB76-4985-4B99-8BFB-21942A3F5698") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUserempty);
export default __webpack_public_path__ + "static/media/icon_userempty.7ec1068a.svg";
export { ForwardRef as ReactComponent };